module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/exchange-174b6df30912b4bc85c5a658187ca212.svg";